import { useState } from 'react'
import { useMeReload } from '../context/MeContext'
import { api } from '../lib/api'
import { trackEvent } from '../lib/config'
import { useNavigateTo } from '../lib/spaPath'
import { Modal, SelectField, SubmitButton } from './common'
import styles from './ChangeProfessionModal.module.scss'

const PROFESSION_NAMES: { key: number; name: string }[] = [
  { key: 1, name: 'Medicina' },
  { key: 4, name: 'Kinesiología' },
  { key: 8, name: 'Matrón' },
  { key: 6, name: 'Enfermería' },
  { key: 3, name: 'Nutrición' },
  { key: 7, name: 'Oftalmología' },
  { key: 2, name: 'Pediatría' },
  { key: 0, name: 'Psicología' },
  { key: 5, name: 'Fonoaudiología' },
]

export function ChangeProfessionModal({ healthCenterId, onClose }: { healthCenterId: number; onClose: () => void }) {
  const [key, setKey] = useState<string>('')
  const [submitting, setSubmitting] = useState(false)
  const reloadMe = useMeReload()
  const navigateTo = useNavigateTo()

  const handleSubmit = async () => {
    if (submitting || key === '') {
      return
    }
    setSubmitting(true)
    const currentUrl = window.location.pathname + window.location.search
    try {
      const result = await api.post<{ redirect: string }>(`/health_centers/${healthCenterId}/admin/change_profession`, {
        profession: { key },
        url: currentUrl,
      })
      trackEvent('Profession Changed', { profession_key: key, success: true }, { transport: 'sendBeacon' })
      if (result.redirect === currentUrl) {
        reloadMe()
      } else {
        navigateTo(result.redirect)
      }
      onClose()
    } catch {
      // The catch swallows the error silently, so this event is the only signal
      // that the change failed.
      trackEvent('Profession Changed', { profession_key: key, success: false })
      setSubmitting(false)
    }
  }

  return (
    <Modal open onClose={onClose} id="modal_appointment" title="Escoge tu nueva profesión" dialogClassName={styles.dialog}>
      <div className="row">
        <form
          id="appointment-calendar-form"
          onSubmit={(event) => {
            event.preventDefault()
            void handleSubmit()
          }}
        >
          <SelectField
            label="Profesión"
            className="col-xs-10 col-xs-offset-1"
            controlClassName="profession-selector"
            controlStyle={{ width: '100%' }}
            placeholder=""
            value={key}
            options={PROFESSION_NAMES.map((profession) => ({ value: profession.key, label: profession.name }))}
            onChange={setKey}
          />
          <SubmitButton label="Enviar" block disabled={submitting} />
        </form>
      </div>
    </Modal>
  )
}
